import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    player1: true,
    initialStatePlayer: false,
    computer: true,
    player2: false,
};

const playerSlice = createSlice({
    name: "playerSlice",
    initialState: initialState,
    reducers: {
        toggleTurn: (state, action) => {
            state.player1 = !state.player1;
            state.computer = !state.computer;
            state.player2 = !state.player2;
            return state;
        },
        resetPlayerState: (state, action) => {
            if (state.initialStatePlayer) {
                state.player1 = false;
                state.computer = true;
                state.player2 = false;
                state.initialStatePlayer = false;
            }
            else {
                state.player1 = true;
                state.computer = false;
                state.player2 = false;
                state.initialStatePlayer = true;
            }
            return state;
        },
        initiallySetPlayerTurn: (state, action) => {
            state.player1 = true;
            state.computer = false;
            state.player2 = false;
            state.initialStatePlayer = true;
            return state;
        }
    },
});

export const { toggleTurn, resetPlayerState, initiallySetPlayerTurn } = playerSlice.actions;
export default playerSlice;
